import React, { useEffect, useState } from 'react';
import WmsSidebar from '../../components/WmsSidebar';
import WmsTopbar from '../../components/wms_topbar';
import { consultarMovimientosInventario } from '../../api.wms.inventario';

const MovimientosInventario = () => {
  const [activeItem, setActiveItem] = useState('inventario');
  const [movimientos, setMovimientos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filtros, setFiltros] = useState({ producto_id: '', tipo: '', cliente_id: '', fecha_inicio: '', fecha_fin: '' });

  const fetchMovimientos = async (filtrosAplicados = filtros) => {
    setLoading(true);
    try {
      const data = await consultarMovimientosInventario(filtrosAplicados);
      setMovimientos(data);
    } catch (err) {
      setError('Error al cargar movimientos');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMovimientos();
    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    setFiltros({ ...filtros, [e.target.name]: e.target.value });
  };

  const handleFiltrar = (e) => {
    e.preventDefault();
    fetchMovimientos(filtros);
  };

  return (
    <div className="flex">
      <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      <div className="transition-all duration-300 flex-1 bg-gray-100 min-h-screen p-6">
        <WmsTopbar />
        <h1 className="text-2xl font-bold mb-4">Movimientos de Inventario</h1>
        <form className="mb-4 flex flex-wrap gap-2 items-end" onSubmit={handleFiltrar}>
          <div>
            <label className="block text-xs font-semibold">Producto ID</label>
            <input type="text" name="producto_id" value={filtros.producto_id} onChange={handleChange} className="border rounded px-2 py-1 text-sm" />
          </div>
          <div>
            <label className="block text-xs font-semibold">Tipo</label>
            <input type="text" name="tipo" value={filtros.tipo} onChange={handleChange} className="border rounded px-2 py-1 text-sm" placeholder="putaway, recepcion..." />
          </div>
          <div>
            <label className="block text-xs font-semibold">Cliente ID</label>
            <input type="text" name="cliente_id" value={filtros.cliente_id} onChange={handleChange} className="border rounded px-2 py-1 text-sm" />
          </div>
          <div>
            <label className="block text-xs font-semibold">Fecha inicio</label>
            <input type="date" name="fecha_inicio" value={filtros.fecha_inicio} onChange={handleChange} className="border rounded px-2 py-1 text-sm" />
          </div>
          <div>
            <label className="block text-xs font-semibold">Fecha fin</label>
            <input type="date" name="fecha_fin" value={filtros.fecha_fin} onChange={handleChange} className="border rounded px-2 py-1 text-sm" />
          </div>
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded text-sm font-semibold">Filtrar</button>
        </form>
        <div className="bg-white rounded-lg shadow p-4">
          {loading && <p>Cargando...</p>}
          {error && <p className="text-red-500">{error}</p>}
          {!loading && !error && (
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm border">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-2 py-1 border">ID</th>
                    <th className="px-2 py-1 border">Fecha</th>
                    <th className="px-2 py-1 border">Producto</th>
                    <th className="px-2 py-1 border">Cantidad</th>
                    <th className="px-2 py-1 border">Origen</th>
                    <th className="px-2 py-1 border">Destino</th>
                    <th className="px-2 py-1 border">Tipo</th>
                    <th className="px-2 py-1 border">Usuario</th>
                    <th className="px-2 py-1 border">Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  {movimientos.map(mov => (
                    <tr key={mov.id}>
                      <td className="border px-2 py-1">{mov.id}</td>
                      <td className="border px-2 py-1">{mov.fecha ? new Date(mov.fecha).toLocaleString() : ''}</td>
                      <td className="border px-2 py-1">{mov.producto_id}</td>
                      <td className="border px-2 py-1">{mov.cantidad}</td>
                      <td className="border px-2 py-1">{mov.origen_id}</td>
                      <td className="border px-2 py-1">{mov.destino_id}</td>
                      <td className="border px-2 py-1">{mov.tipo}</td>
                      <td className="border px-2 py-1">{mov.usuario_id}</td>
                      <td className="border px-2 py-1">{mov.observaciones || ''}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MovimientosInventario;
